/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonitoredObjectFleetType,
    MonitoredObjectFleetTypeFromJSON,
    MonitoredObjectFleetTypeFromJSONTyped,
    MonitoredObjectFleetTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MoPricePerKm
 */
export interface MoPricePerKm {
    /**
     * 
     * @type {string}
     * @memberof MoPricePerKm
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof MoPricePerKm
     */
    avgPricePerKm: number;
    /**
     * 
     * @type {number}
     * @memberof MoPricePerKm
     */
    monitoredObjectId: number;
    /**
     * 
     * @type {number}
     * @memberof MoPricePerKm
     */
    distance: number;
    /**
     * 
     * @type {MonitoredObjectFleetType}
     * @memberof MoPricePerKm
     */
    fleetType: MonitoredObjectFleetType;
}

export function MoPricePerKmFromJSON(json: any): MoPricePerKm {
    return MoPricePerKmFromJSONTyped(json, false);
}

export function MoPricePerKmFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoPricePerKm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': json['currency'],
        'avgPricePerKm': json['avg_price_per_km'],
        'monitoredObjectId': json['monitored_object_id'],
        'distance': json['distance'],
        'fleetType': MonitoredObjectFleetTypeFromJSON(json['fleet_type']),
    };
}

export function MoPricePerKmToJSON(value?: MoPricePerKm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'avg_price_per_km': value.avgPricePerKm,
        'monitored_object_id': value.monitoredObjectId,
        'distance': value.distance,
        'fleet_type': MonitoredObjectFleetTypeToJSON(value.fleetType),
    };
}


